import SunshineTag from 'components/_core/SunshineTag';
import {
  NavigationStep,
  NavigationStepStatus,
} from 'features/Onboarding/components/OBNavigation/NavigationContext';

import { State } from '../machine';
import locales from './locales';
import { Section, SECTIONS, STATE_TO_SECTION } from './sections';

/**
 * Takes the current State of the capital deposit Mandatee machine
 * and returns the relevant navigation steps assignable to NavigationContext.
 */
const getNavigationSteps = ({
  legalName,
  state,
}: {
  state: State;
  legalName: string | null;
}): NavigationStep[] => {
  const currentSection = STATE_TO_SECTION[state];
  const indexOfCurrentSection =
    currentSection === null ? null : SECTIONS.indexOf(currentSection);

  const getSectionStatus = (
    sectionIndex: number,
    activeSectionIndex: number,
  ) => {
    if (sectionIndex === activeSectionIndex) {
      return NavigationStepStatus.Ongoing;
    }

    return sectionIndex > activeSectionIndex
      ? NavigationStepStatus.Todo
      : NavigationStepStatus.Done;
  };

  return indexOfCurrentSection === null
    ? []
    : SECTIONS.map((section, index) => {
        const slot =
          section === Section.CompanyInformation && legalName ? (
            <SunshineTag
              colorScheme="grey"
              icon="company"
              marginTop="space-8"
              size="sm"
            >
              {legalName}
            </SunshineTag>
          ) : null;

        return {
          slot,
          status: getSectionStatus(index, indexOfCurrentSection),
          title: locales[section].label,
        };
      });
};

export default getNavigationSteps;
